import type {
    SendOtpResponse,
    VerifyOtpResponse,
} from "../types/auth.types";
import { ApiError } from "./ApiError";

const API_BASE_URL =
    import.meta.env.VITE_API_BASE_URL || "https://prod-native-api.cleverpe.com/api";




const safeJson = async (response: Response) => {
    try {
        return await response.json();
    } catch {
        return null;
    }
};


export const sendOtp = async (
    journeyId: string
): Promise<SendOtpResponse> => {

    const response = await fetch(
        `${API_BASE_URL}/auth/send-otp`,
        {
            method: "POST",

            headers: {
                "Content-Type": "application/json",
            },

            body: JSON.stringify({
                journeyId,
            }),
        }
    );

    const data = await response.json();

    if (!response.ok) {
        throw new ApiError(
            data?.message ||
            "Unable to send OTP.",
            response.status,
            data
        );
    }

    return data;
};

export const verifyOtp = async (
    journeyId: string,
    otp: string,
    otpToken: string
): Promise<VerifyOtpResponse> => {

    const response = await fetch(
        `${API_BASE_URL}/auth/verify-otp`,
        {
            method: "POST",

            headers: {
                "Content-Type": "application/json",
            },

            body: JSON.stringify({
                journeyId,
                otp,
                otpToken,
            }),
        }
    );

    const data = await safeJson(response);

    if (!response.ok) {
        throw new ApiError(
            data?.message ||
            "Unable to verify OTP.",
            response.status,
            data
        );
    }

    return data;
};